import { ChangeDetectionStrategy, Component, inject, Inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { rxState } from '@rx-angular/state';
import { RxLet } from '@rx-angular/template/let';
import { ENVIRONMENT } from '../../environment/environment';

@Component({
  selector: 'lib-icon-set',
  imports: [RxLet],
  standalone: true,
  templateUrl: './icon-set.component.html',
  styleUrls: ['./icon-set.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconSetComponent {

  private state = rxState<{ icons: SafeHtml }>();
  readonly iconSet$ = this.state.select('icons');
  
  constructor(
    private sanitizer: DomSanitizer,
  ) {

    this.state.set({icons: this.sanitizer.bypassSecurityTrustHtml(inject(ENVIRONMENT).iconSet)});
  }
}
